var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 477.595,
    height: 496.053,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.071 136.704c4.249-5.563 17.196-17.231 15.595-23.789-2.203-9.018.507 5.107-3.229-3.778-1.716-4.078-11.41-18.072-19.015-34.223-.956-11.405 1.985-29.625 3.515-33.125 3.099-7.09 6.95-20.486 6.72-28.059-.171-5.639-6.202-10.76-11.461-7.605-2.138 1.284-4.861 5.018-6.281 14.754-1.353 9.278-5.686 13.104-11.484 16.235-11.26-10.378-12.791-9.985-21.873-18.258C44.201 9.425 33.42-1.879 28.894 1.742c-9.525 7.613 17.879 24.44 20.905 34.221C35.415 25.266 15.943 5.684 8.937 12.19 1.932 18.697 34.59 35.011 40.306 43.737c-8.39-.862-35.041-19.43-38.341-12.844-3.176 6.336 2.461 8.262 10.139 13.301 6.689 4.39 17.379 8.918 20.574 11.314-4.245-.427-23.846-7.158-26.426-3.411-1.371 1.99 1.413 7.941 6.482 9.837 5.853 2.185 15.09 4.664 17.74 6.977 6.019 5.26 20.485 17.452 26.588 19.081 6.844 1.819 8.88 1.974 17.001 2.006 6.753 6.9 18.497 34.496 28.008 46.706",
    fill: "#F3B9A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.071 136.704c4.249-5.563 17.196-17.231 15.595-23.789-2.203-9.018.507 5.107-3.229-3.778-1.716-4.078-11.41-18.072-19.015-34.223-.956-11.405 1.985-29.625 3.515-33.125 3.099-7.09 6.95-20.486 6.72-28.059-.171-5.639-6.202-10.76-11.461-7.605-2.138 1.284-4.861 5.018-6.281 14.754-1.353 9.278-5.686 13.104-11.484 16.235-11.26-10.378-12.791-9.985-21.873-18.258C44.201 9.425 33.42-1.879 28.894 1.742c-9.525 7.613 17.879 24.44 20.905 34.221C35.415 25.266 15.943 5.684 8.937 12.19 1.932 18.697 34.59 35.011 40.306 43.737c-8.39-.862-35.041-19.43-38.341-12.844-3.176 6.336 2.461 8.262 10.139 13.301 6.689 4.39 17.379 8.918 20.574 11.314-4.245-.427-23.846-7.158-26.426-3.411-1.371 1.99 1.413 7.941 6.482 9.837 5.853 2.185 15.09 4.664 17.74 6.977 6.019 5.26 20.485 17.452 26.588 19.081 6.844 1.819 8.88 1.974 17.001 2.006 6.753 6.9 18.497 34.496 28.008 46.706z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.31 39.322c-4.002 4.98-4.892 20.315-3.096 26.451",
    fill: "#F3B9A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.31 39.322c-4.002 4.98-4.892 20.315-3.096 26.451",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M231.221 217.615c-15.141-2.16-20.428 5.438-35.057-.14-6.999-2.665-8.34-6.154-12.348-12.356-9.203-14.255-18.112-28.519-27.569-42.769-6.096-9.183-38.97-65.569-43.717-79.828-9.498 12.337-29.466 25.659-40.871 28.512 17.118 19 42.778 66.527 50.376 80.784 3.418 6.413 17.108 29.464 28.512 62.719 3.28 9.574 11.402 60.358 12.359 73.188.858 11.475 4.174 52.308 2.838 77.953 4.02.45 62.004-3.168 69.377-2.85 24.057 1.041 68.049 14.616 92.201 11.381 2.775-22.845-9.33-17.137-12.359-50.362-.951-10.467 1.828-36.096 1.89-53.587 7.199 17.599 19.869 34.094 19.399 51.201 20.91 23.766 41.415-6.525 40.495-11.868-2.095-12.132-26.03-60.266-35.095-77.733-5.985-11.52-17.615-26.382-27.594-31.602-12.048-6.297-22.914-9.375-34.799-10.797-13.509-1.622-18.633-.596-30.61-4.204-5.821-1.754-11.373-6.772-17.428-7.642",
    fill: "#7A8BAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M231.221 217.615c-15.141-2.16-20.428 5.438-35.057-.14-6.999-2.665-8.34-6.154-12.348-12.356-9.203-14.255-18.112-28.519-27.569-42.769-6.096-9.183-38.97-65.569-43.717-79.828-9.498 12.337-29.466 25.659-40.871 28.512 17.118 19 42.778 66.527 50.376 80.784 3.418 6.413 17.108 29.464 28.512 62.719 3.28 9.574 11.402 60.358 12.359 73.188.858 11.475 4.174 52.308 2.838 77.953 4.02.45 62.004-3.168 69.377-2.85 24.057 1.041 68.049 14.616 92.201 11.381 2.775-22.845-9.33-17.137-12.359-50.362-.951-10.467 1.828-36.096 1.89-53.587 7.199 17.599 19.869 34.094 19.399 51.201 20.91 23.766 41.415-6.525 40.495-11.868-2.095-12.132-26.03-60.266-35.095-77.733-5.985-11.52-17.615-26.382-27.594-31.602-12.048-6.297-22.914-9.375-34.799-10.797-13.509-1.622-18.633-.596-30.61-4.204-5.821-1.754-11.373-6.772-17.428-7.642z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M475.907 480.75l-226.517 9.495L30.17 480.3l37.261-111.386 358.361.905 50.115 110.931",
    fill: "#F4BE8A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M475.907 480.75l-226.517 9.495L30.17 480.3l37.261-111.386 358.361.905z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M380.547 382.847c4.91-5.646-1.495-12.928-8.55-19.001-15.87-13.678-39.435 13.526-47.875 24.019-6.932 8.621-7.82 20.4 3.2 22.538 17.185 3.333 41.67-14.274 53.225-27.556",
    fill: "#DAA275"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M279.798 242.192c-2.095-10.167-10.936-18.351-19.96-21.865-11.552-4.498-28.19-9.822-39.914-6.658-17.077 4.614-29.569 18.839-26.273 36.591 4.392 23.652 27.216 32.261 46.001 31.6 20.055-.708 45.733-12.509 40.146-39.668",
    fill: "#7A8BAD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M279.798 242.192c-2.095-10.167-10.936-18.351-19.96-21.865-11.552-4.498-28.19-9.822-39.914-6.658-17.077 4.614-29.569 18.839-26.273 36.591 4.392 23.652 27.216 32.261 46.001 31.6 20.055-.708 45.733-12.509 40.146-39.668z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M267.452 235.536c-6.395-15.544-6.589-18.558-17.12-23.742-19.331-9.52-24.112-4.566-28.57-3.589-4.87 1.065-1.938 2.717-5.158 6.436-8.311 9.607-15.41 21.415-12.828 32.3 2.364 9.98 6.679 16.122 14.677 20.522 8.264 4.544 26.312 4.804 35.198.797 12.403-5.595 20.443-16.573 13.801-32.724",
    fill: "#E5A98F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M267.452 235.536c-6.395-15.544-6.589-18.558-17.12-23.742-19.331-9.52-24.112-4.566-28.57-3.589-4.87 1.065-1.938 2.717-5.158 6.436-8.311 9.607-15.41 21.415-12.828 32.3 2.364 9.98 6.679 16.122 14.677 20.522 8.264 4.544 26.312 4.804 35.198.797 12.403-5.595 20.443-16.573 13.801-32.724z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.129 198.64c.29-7.059 1.338-18.112-3.033-24.122-3.354-4.612-7.85-6.873-13.118-8.194-7.026-1.761-13.754 3.563-13.787 10.452-.042 8.617 6.656 18.072 12.83 23.773 6.399 5.905 16.599 10.384 17.108-1.909",
    fill: "#F3B9A2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M181.129 198.64c.29-7.059 1.338-18.112-3.033-24.122-3.354-4.612-7.85-6.873-13.118-8.194-7.026-1.761-13.754 3.563-13.787 10.452-.042 8.617 6.656 18.072 12.83 23.773 6.399 5.905 16.599 10.384 17.108-1.909z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M286.764 199.264c-.292-7.054-1.339-18.112 3.032-24.122 3.352-4.61 7.852-6.874 13.12-8.194 7.027-1.762 13.5 3.427 13.535 10.315.041 8.619-6.407 18.209-12.583 23.909-6.394 5.906-16.596 10.387-17.104-1.908",
    fill: "#F3B9A2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M286.764 199.264c-.292-7.054-1.339-18.112 3.032-24.122 3.352-4.61 7.852-6.874 13.12-8.194 7.027-1.762 13.5 3.427 13.535 10.315.041 8.619-6.407 18.209-12.583 23.909-6.394 5.906-16.596 10.387-17.104-1.908z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M290.246 200.07c4.95-20.349 6.995-58.13-7.059-73.209-12.86-13.8-43.709-33.436-63.351-26.292-12.502 4.546-23.213 24.154-32.134 33.857-21.201 23.067-15.933 61.528-1.677 82.441 9.384 13.77 31.869 31.114 50.052 30.097 17.105-.956 47.677-20.208 54.169-46.894",
    fill: "#F3B9A2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M290.246 200.07c4.95-20.349 6.995-58.13-7.059-73.209-12.86-13.8-43.709-33.436-63.351-26.292-12.502 4.546-23.213 24.154-32.134 33.857-21.201 23.067-15.933 61.528-1.677 82.441 9.384 13.77 31.869 31.114 50.052 30.097 17.105-.956 47.677-20.208 54.169-46.894zm-92.594-35.405c1.606-16.005 21.326-15.234 25.606-2.405m19.194 0c3.203-12.801 19.721-16.031 24-3.201",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M211.368 171.885c3.855.497 4.066 7.776-.382 7.036-2.363-.392-3.476-7.538.382-7.036M254.357 171.26c4.412-.325 3.855 7.456-.593 6.713-2.363-.394-3.286-6.426.593-6.713",
    fill: "#1A1919"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M233.054 191.061c-7.753-2.109-7.2 7.8-2.677 10.284",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M257.219 205.625c-.8 8.517-3.301 14.841-6.606 19.327-10.061-1.189-18.161-1.189-31.659.956-4.54-4.472-8.235-10.694-8.777-18.384 8.777 9.633 36.079 11.137 47.042-1.899",
    fill: "#CD6A5F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M257.219 205.625c-.8 8.517-3.301 14.841-6.606 19.327-10.061-1.189-18.161-1.189-31.659.956-4.54-4.472-8.235-10.694-8.777-18.384 8.777 9.633 36.079 11.137 47.042-1.899z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M218.654 225.563c5.705-6.597 24.131-6.153 32.4-.9-3.6 4.497-8.674 8.529-15.802 8.796-6.171.225-11.198-2.498-16.598-7.896",
    fill: "#E47272"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M218.654 225.563c5.705-6.597 24.131-6.153 32.4-.9-3.6 4.497-8.674 8.529-15.802 8.796-6.171.225-11.198-2.498-16.598-7.896z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M248.757 382.524l92.51-2.205 15.99 66.206-102.165.955-6.335-64.956",
    fill: "#FFFFFE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M248.757 382.524l92.51-2.205 15.99 66.206-102.165.955z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M186.039 382.524l-12.202 64.471 90.762.955-3.804-65.735-74.756.309",
    fill: "#FFFFFE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M186.039 382.524l-12.202 64.471 90.762.955-3.804-65.735z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M186.183 436.075l63.207.94",
    fill: "#FFFFFE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M186.183 436.075l63.207.94",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M192.371 392.824l57.019-.792",
    fill: "#F0AC84"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M192.371 392.824l57.019-.792",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M191.415 401.38l59.001 2.676",
    fill: "#F0AC84"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M191.415 401.38l59.001 2.676",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M189.034 412.782l62.384 2.276",
    fill: "#F0AC84"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M189.034 412.782l62.384 2.276",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M188.565 423.716l59.871 1.898",
    fill: "#F0AC84"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M188.565 423.716l59.871 1.898",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M278.023 436.635l65.934-.56",
    fill: "#FFFFFE"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M278.023 436.635l65.934-.56",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M277.308 394.213l57.974-1.388",
    fill: "#F0AC84"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M277.308 394.213l57.974-1.388",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M277.764 403.719l57.493-1.36",
    fill: "#F0AC84"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M277.764 403.719l57.493-1.36",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M277.431 415.163l60.341-1.427",
    fill: "#F0AC84"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M277.431 415.163l60.341-1.427",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M278.855 425.6l59.892-1.007",
    fill: "#F0AC84"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M278.855 425.6l59.892-1.007",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M335.482 385.958c-7.04-13.594-15.12-10.913-27.646-10.238-8.069 10.449 13.784 32.787 27.086 29.466 7.06-1.762 3.535-13.482.56-19.228",
    fill: "#6C7A97"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M335.482 385.958c-7.04-13.594-15.12-10.913-27.646-10.238-8.069 10.449 13.784 32.787 27.086 29.466 7.06-1.762 3.535-13.482.56-19.228z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M304.515 385.698c-8.056.457-15.614-2.145-24.075-1.264-7.788.814-13.785 4.824-21.07 8.391-5.013 2.466-18.413 11.975-8.714 13.786 10.139 1.896 16-8.405 22.174-6.979-5.703 5.716-16.812 16.284-20.119 21.705-2.798 4.593-5.379 10.464-5.848 13.783-.473 3.325 2.668 8.015 6.333 5.07 3.159-2.54 4.735-8.011 9.024-12.668 4.036-4.387 10.301-11.674 12.521-12.049-2.431 6.651-8.368 12.202-11.097 18.223-2.545 5.609-7.436 16.314-2.218 19.164 5.218 2.85 8.847-5.815 13.151-16.315 2.652-6.473 7.761-9.67 11.877-12.829-1.542 5.372-4.764 9.708-7.13 16.154-4.04 11.01-5.38 16.505-1.893 18.06 3.407 1.52 9.149-2.38 12.356-12.83 3.529-6.115 5.357-11.899 10.922-14.255-2.283 8.985-10.449 26.61-3.321 25.185 8.276-1.655 11.751-11.975 14.725-19.645 1.74-4.494 5.293-11.628 7.611-16.476 2.801-5.85.252-12.984 3.163-17.737 7.125-7.599 21.05-14.231 21.07-17.897.035-6.487-9.66-9.884-13.785-13.786-7.542 5.334-15.68 9.506-25.657 15.209",
    fill: "#F3B9A2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M304.515 385.698c-8.056.457-15.614-2.145-24.075-1.264-7.788.814-13.785 4.824-21.07 8.391-5.013 2.466-18.413 11.975-8.714 13.786 10.139 1.896 16-8.405 22.174-6.979-5.703 5.716-16.812 16.284-20.119 21.705-2.798 4.593-5.379 10.464-5.848 13.783-.473 3.325 2.668 8.015 6.333 5.07 3.159-2.54 4.735-8.011 9.024-12.668 4.036-4.387 10.301-11.674 12.521-12.049-2.431 6.651-8.368 12.202-11.097 18.223-2.545 5.609-7.436 16.314-2.218 19.164 5.218 2.85 8.847-5.815 13.151-16.315 2.652-6.473 7.761-9.67 11.877-12.829-1.542 5.372-4.764 9.708-7.13 16.154-4.04 11.01-5.38 16.505-1.893 18.06 3.407 1.52 9.149-2.38 12.356-12.83 3.529-6.115 5.357-11.899 10.922-14.255-2.283 8.985-10.449 26.61-3.321 25.185 8.276-1.655 11.751-11.975 14.725-19.645 1.74-4.494 5.293-11.628 7.611-16.476 2.801-5.85.252-12.984 3.163-17.737 7.125-7.599 21.05-14.231 21.07-17.897.035-6.487-9.66-9.884-13.785-13.786-7.542 5.334-15.68 9.506-25.657 15.209z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M342.852 351.256c-6.86 7.395-15.6 10.809-35.486 24.935 24.701-.471 27.081 18.532 29.466 28.512 12.83-6.176 9.34-3.399 20.91-11.405 9.995-6.921 11.73-8.058 19.005-17.578 6.17-8.081 3.605-17.297-2.095-33.464",
    fill: "#7A8BAD"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M342.852 351.256c-6.86 7.395-15.6 10.809-35.486 24.935 24.701-.471 27.081 18.532 29.466 28.512 12.83-6.176 9.34-3.399 20.91-11.405 9.995-6.921 11.73-8.058 19.005-17.578 6.17-8.081 3.605-17.297-2.095-33.464",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M326.057 459.835l-19.016 8.235 23.451 2.525 93.775-15.52-.63-8.54-97.58 13.3",
    fill: "#DAA275"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M325.657 451.59l-23.293 8.8 24.243 2.14 13.545-8.085-14.495-2.855",
    fill: "#F3CCA6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M325.657 451.59l-23.293 8.8 24.243 2.14 13.545-8.085z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M329.702 458.965l-2.85-2.14 2.38-2.38-2.14-3.565 94.315-11.4 2.375 8.55-96.22 14.255 2.14-3.32",
    fill: "#6E8073"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M329.702 458.965l-2.85-2.14 2.38-2.38-2.14-3.565 94.315-11.4 2.375 8.55-96.22 14.255z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M313.548 456.825l.229 4.035-6.642-1.425 6.413-2.61",
    fill: "#1A1919"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M73.555 467.435l69.701.635 78.564 3.17-17.737-44.351-95.681-1.894-34.847 42.44",
    fill: "#DAA275"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M77.058 462.48c-2.543-3.2-1.588-7.045-1.588-7.045s18.553-43.757 22.376-50.469c14.824-7.468 53.637-5.644 60.311 5.919 14.257-15.21 58.073-3.904 68.426 6.657 0 5.704-.956 47.043-2.853 53.688-27.083-19.005-60.534-19.38-65.467-15.065-6.959 6.1-12.949 9.845-12.949 9.845s-9.094-6.73-13.224-8.935c-4.129-2.205-36.183-19.575-55.032 5.405",
    fill: "#FFFFFE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M77.058 462.48c-2.543-3.2-1.588-7.045-1.588-7.045s18.553-43.757 22.376-50.469c14.824-7.468 53.637-5.644 60.311 5.919 14.257-15.21 58.073-3.904 68.426 6.657 0 5.704-.956 47.043-2.853 53.688-27.083-19.005-60.534-19.38-65.467-15.065-6.959 6.1-12.949 9.845-12.949 9.845s-9.094-6.73-13.224-8.935c-4.129-2.205-36.183-19.575-55.032 5.405z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M157.084 411.579l-13.195 53.951",
    fill: "#7A8BAD"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M157.084 411.579l-13.195 53.951",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M75.47 455.435s-1.911 7.585-2.039 12.81c25.427-23.505 51.834-10.305 55.954-7.58 5.098 3.375 3.436 1.06 9.202 8.075l11.508.285s3.267-5.075 7.504-7.65c7.439-4.52 35.672-6.645 56.625 12.705 4.758-.94 6.715.24 10.463-3.32-18.431-15.62-58.086-34.255-80.187-8.15-1.653-17.295-48.115-28.085-69.03-7.175",
    fill: "#CBCCCB"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M75.47 455.435s-1.911 7.585-2.039 12.81c25.427-23.505 51.834-10.305 55.954-7.58 5.098 3.375 3.436 1.06 9.202 8.075l11.508.285s3.267-5.075 7.504-7.65c7.439-4.52 35.672-6.645 56.625 12.705 4.758-.94 6.715.24 10.463-3.32-18.431-15.62-58.086-34.255-80.187-8.15-1.653-17.295-48.115-28.085-69.03-7.175zm12.979-15.08c9.15-8.969 43.828-10.49 53.648 5.295m-48.803-14.753c11.95-9.637 46.092-9.103 51.551 2.799m-47.651-12.254c8.63-7.523 38.627-10.557 50.029 2.274m14.726-1.425c16.299-7.365 43.25-4.278 57.033 8.081m-54.652-15.694c19.955-9.975 43.477-.577 55.125 7.139m-118.682-8.897c9.15-8.967 43.116-7.265 48.832 3.183",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M160.525 430.845c-2.136 4.845-5.011 13.285-5.738 16.765 17.559-13.06 44.7-6.32 62.288 6.515 1.425-6.66.482-8.07.956-14.255-11.059-9.864-39.516-16.965-57.506-9.025",
    fill: "#E4E4E3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M160.525 430.845c-2.136 4.845-5.011 13.285-5.738 16.765 17.559-13.06 44.7-6.32 62.288 6.515 1.425-6.66.482-8.07.956-14.255-11.059-9.864-39.516-16.965-57.506-9.025z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M365.342 411.045l-7.29 4.751 35.165 18.999 23.44-15.826-26.6-9.508-24.715 1.584",
    fill: "#DAA275"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M375.477 412.311l-9.815-10.463 14.885-8.228 30.1 11.404-14.9 14.885-20.27-7.598",
    fill: "#FFFFFE"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M375.477 412.311l-9.815-10.463 14.885-8.228 30.1 11.404-14.9 14.885z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M392.587 418.013l18.06-12.358-.955 9.817-14.575 11.403-2.53-8.862",
    fill: "#FFFFFE"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M392.587 418.013l18.06-12.358-.955 9.817-14.575 11.403z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M365.652 401.848l-.96 8.878 30.41 15.825 1.26-10.771-30.71-13.932",
    fill: "#FFFFFE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M365.652 401.848l-.96 8.878 30.41 15.825 1.26-10.771z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M375.477 412.311l-9.815-10.463 14.885-8.229 19.96 7.291-16.475 11.401h-8.555",
    fill: "#E46E6E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M375.477 412.311l-9.815-10.463 14.885-8.229 19.96 7.291-16.475 11.401z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M365.662 402.172l-.955 8.874 20.915 11.081.94-11.081-20.9-8.874",
    fill: "#C56161"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M365.662 402.172l-.955 8.874 20.915 11.081.94-11.081z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M475.587 494.99H30.803l-.952-14.255h446.681l-.945 14.255",
    fill: "#DAA275"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M475.587 494.99H30.803l-.952-14.255h446.681z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M271.66 164.914c-7.607-11.457-13.05-40.247-15.604-54.654-9.849 20.439-16.805 33.603-36.628 41.098 2.18-9.711 2.301-20.068 3.785-29.967-6.134 17.306-18.363 30.471-30.849 43.424-.392-3.637-4.131-12-4.57-12.065-4.46 11.522-10.014 35.283-10.014 46.687-6.31-6.672-15.249-30.361-16.782-38.958-3.154-17.699.619-29.915 9.024-47.054 11.887-24.247 41.669-34.555 67.012-34.213 16.898.226 46.57 8.082 59.399 31.36 9.995 18.135 9.856 26.325 8.554 47.053-.58 9.25-7.733 34.566-14.417 40.87 1.896-11.874-9.269-43.012-11.443-49.641-3.606 7.345-3.135 9.244-7.467 16.06",
    fill: "#946451"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M271.66 164.914c-7.607-11.457-13.05-40.247-15.604-54.654-9.849 20.439-16.805 33.603-36.628 41.098 2.18-9.711 2.301-20.068 3.785-29.967-6.134 17.306-18.363 30.471-30.849 43.424-.392-3.637-4.131-12-4.57-12.065-4.46 11.522-10.014 35.283-10.014 46.687-6.31-6.672-15.249-30.361-16.782-38.958-3.154-17.699.619-29.915 9.024-47.054 11.887-24.247 41.669-34.555 67.012-34.213 16.898.226 46.57 8.082 59.399 31.36 9.995 18.135 9.856 26.325 8.554 47.053-.58 9.25-7.733 34.566-14.417 40.87 1.896-11.874-9.269-43.012-11.443-49.641-3.606 7.345-3.135 9.244-7.467 16.06z",
    stroke: "#1A1919",
    strokeWidth: 2.126,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondary);
export default __webpack_public_path__ + "static/media/secondary.d74e1f4ca429b1ae062871bd682c6667.svg";
export { ForwardRef as ReactComponent };